/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EvidenceSerialiser } from './EvidenceSerialiser';
import {
  EvidenceSerialiserFromJSON,
  EvidenceSerialiserFromJSONTyped,
  EvidenceSerialiserToJSON,
} from './EvidenceSerialiser';
import type { EnhancedGovernance } from './EnhancedGovernance';
import {
  EnhancedGovernanceFromJSON,
  EnhancedGovernanceFromJSONTyped,
  EnhancedGovernanceToJSON,
} from './EnhancedGovernance';

/**
 *
 * @export
 * @interface PatchedGovernanceAnswer
 */
export interface PatchedGovernanceAnswer {
  /**
   *
   * @type {number}
   * @memberof PatchedGovernanceAnswer
   */
  readonly id?: number;
  /**
   *
   * @type {number}
   * @memberof PatchedGovernanceAnswer
   */
  useCase?: number;
  /**
   *
   * @type {EnhancedGovernance}
   * @memberof PatchedGovernanceAnswer
   */
  readonly requirement?: EnhancedGovernance;
  /**
   *
   * @type {boolean}
   * @memberof PatchedGovernanceAnswer
   */
  isFulfilled?: boolean;
  /**
   *
   * @type {Array<EvidenceSerialiser>}
   * @memberof PatchedGovernanceAnswer
   */
  readonly evidence?: Array<EvidenceSerialiser>;
  /**
   *
   * @type {Array<number>}
   * @memberof PatchedGovernanceAnswer
   */
  evidenceIds?: Array<number>;
  /**
   *
   * @type {string}
   * @memberof PatchedGovernanceAnswer
   */
  readonly show?: string;
}

/**
 * Check if a given object implements the PatchedGovernanceAnswer interface.
 */
export function instanceOfPatchedGovernanceAnswer(value: object): value is PatchedGovernanceAnswer {
  return true;
}

export function PatchedGovernanceAnswerFromJSON(json: any): PatchedGovernanceAnswer {
  return PatchedGovernanceAnswerFromJSONTyped(json, false);
}

export function PatchedGovernanceAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedGovernanceAnswer {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    useCase: json['use_case'] == null ? undefined : json['use_case'],
    requirement: json['requirement'] == null ? undefined : EnhancedGovernanceFromJSON(json['requirement']),
    isFulfilled: json['is_fulfilled'] == null ? undefined : json['is_fulfilled'],
    evidence: json['evidence'] == null ? undefined : (json['evidence'] as Array<any>).map(EvidenceSerialiserFromJSON),
    evidenceIds: json['evidence_ids'] == null ? undefined : json['evidence_ids'],
    show: json['show'] == null ? undefined : json['show'],
  };
}

export function PatchedGovernanceAnswerToJSON(
  value?: Omit<PatchedGovernanceAnswer, 'id' | 'requirement' | 'evidence' | 'show'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    use_case: value['useCase'],
    is_fulfilled: value['isFulfilled'],
    evidence_ids: value['evidenceIds'],
  };
}
